const EMAIL_PATTERN = /^((?!\.)[\w-_.]*[^.])(@\w+)(\.\w+(\.\w+)?[^.\W])$/
const PHONE_NUMBER = /(^(1?)(\s?)([\s]?)((\(\d{3}\))|(\d{3}))([\s]?)([\s-]?)(\d{3})([\s-]?)(\d{4})+$)/

export const isRelativeUrl = (url: string): boolean => {
  return url.startsWith('/') && !url.startsWith('//')
}

export const isHashUrl = (url: string): boolean => {
  return url.startsWith('#') || (isRelativeUrl(url) && url.includes('#'))
}

export const isEmailAddress = (url: string): boolean => {
  return EMAIL_PATTERN.test(url?.replace('mailto:', '') || '')
}

export const isTelephoneNumber = (url: string): boolean => {
  return PHONE_NUMBER.test(url?.replace('tel:', '') || '')
}

export const prependMailTo = (url: string): string => {
  return isEmailAddress(url) && !url.startsWith('mailto:') ? `mailto:${url}` : url
}

export const prependTel = (url: string): string => {
  return isTelephoneNumber(url) && !url.startsWith('tel:') ? `tel:${url}` : url
}

export const formatExternalUrl = (url: string): string => {
  return url ? (url.startsWith('//') ? `https:${url}` : url) : ''
}
